const Templates = () => import(/* webpackChunkName: "v-workflows" */ '@/components/page/workflows/Templates')
const Processes = () => import(/* webpackChunkName: "v-workflows" */ '@/components/page/workflows/Processes')
const Process = () => import(/* webpackChunkName: "v-workflows" */ '@/components/page/workflows/Process')
const Instance = () => import(/* webpackChunkName: "v-workflows" */ '@/components/page/workflows/Instance')

const routes = [
  {
    path: 'workflows/templates',
    component: Templates,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      hasFloatingButton: true
    }
  }, {
    path: 'workflows/:state(running|completed)',
    component: Processes,
    props: true,
    meta: {
      roles: ['USER', 'ADMIN', 'SUPER_ADMIN']
    }
  }, {
    path: 'workflows/:id',
    component: Process,
    props: true,
    meta: {
      roles: ['USER', 'ADMIN', 'SUPER_ADMIN']
    }
  }, {
    path: 'workflows/result/:id',
    component: Instance,
    props: true,
    meta: {
      roles: ['USER', 'ADMIN', 'SUPER_ADMIN']
    }
  }
]

export default routes
